import { render, staticRenderFns } from "./CryptoCurrencyIcon.vue?vue&type=template&id=8df27fc2&"
import script from "./CryptoCurrencyIcon.vue?vue&type=script&lang=js&"
export * from "./CryptoCurrencyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports